<script lang="ts" setup>
import { ElNotification } from "element-plus";
import {ref, inject, onBeforeMount} from "vue";
import deviceApi from "@/deviceApi";

const worker:Worker = inject("worker") as Worker;
const refAudio = ref<HTMLAudioElement | null>(null);

worker.onmessage = (event) => {
  if (deviceApi.isApp()) return;
  if (event.data.type === "notification") {
    try {
      refAudio.value?.play().catch((e: any) => {
        // Ignore AbortError (element removed from DOM during navigation/unmount)
        if (e.name !== 'AbortError') {
          console.error("Audio play error:", e);
        }
      });
    } catch (e: any) {
      // Ignore AbortError from synchronous throw
      if (e.name !== 'AbortError') {
        console.error("Audio play error:", e);
      }
    }
    ElNotification({
      title: "CheckMate notification",
      message: event.data.message,
      type: "info",
      duration: 5000,
      showClose: true
    });
  }
};

onBeforeMount(() => {
  if (!('Notification' in window && 'requestPermission' in window.Notification)) {
        console.log("Notification is not supported.");
        return;
    }
    if (window.Notification && window.Notification.permission !== "granted") {
        window.Notification.requestPermission(function (p) {
            if (p === "granted") {
                console.log("Notification permission granted.");
            } else {
                console.log("Notification permission denied.");
            }
        });
    }
});

</script>
<template>
  <div>
    <audio ref="refAudio" autoplay="false">
      <source src="/audio/notification.mp3" type="audio/mp3">
    </audio>
  </div>
</template>